// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Layout_navbar__2Jj_v","logo":"Layout_logo__2c34V","footer":"Layout_footer__7ZyTp"};